import { render, staticRenderFns } from "./BuyerSection.vue?vue&type=template&id=3af810a8&scoped=true&"
import script from "./BuyerSection.vue?vue&type=script&lang=js&"
export * from "./BuyerSection.vue?vue&type=script&lang=js&"
import style0 from "./BuyerSection.vue?vue&type=style&index=0&id=3af810a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af810a8",
  null
  
)

/* custom blocks */
import block0 from "./BuyerSection.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VContainer,VRow,VTextField,VTextarea})
